import React from 'react';

export default function Summary({ rowsCount }) {
  return (
    <div className="d-flex justify-content-end">
      {`Nr. de Clientes: ${rowsCount}`}
    </div>
  )
}
